import React from 'react';
import { PropTypes } from 'prop-types';
import { FormattedHTMLMessage, injectIntl } from 'react-intl';
import { history } from 'containers/App';

import ErrorPage from 'components/Errors/ErrorPage';

const UnauthorisedError = ({ intl }) => <ErrorPage title={ intl.formatMessage({ id: 'unauthorizedPage.title' }) } type="server" showButton onButtonClick={ () => { history.push('/'); window.location.reload(); } }>
  <FormattedHTMLMessage id="unauthorizedPage.content" />
</ErrorPage>;

UnauthorisedError.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired
};

export default injectIntl(UnauthorisedError);
